import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_legal')({
  async beforeLoad({ context }) {},
  async loader({ context }) {
    const i18ng = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/mui');
    const title = i18ng.t('Legal | MINT');

    return { title };
  },
  head({ loaderData }) {
    const title = loaderData?.title;

    return {
      meta: [
        {
          title,
        },
      ],
    };
  },
});
